export default {
  index: [
    {
      path: '/ptyhq',
      component: resolve => require(['./ptyhqIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/pt_yhq/_router.js